
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^((10|23|76)7|5|889|98)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
